<div class="header col-12">
  <div class="md:col-2 div-padding">
    <img
      src="assets/icons/logo-Horizontal.svg"
      alt="Genetics Logo"
      class="logo-Horizontal cursor-pointer"
      routerLink="/my-orders" />
  </div>
  @if (loginState === ELoginStatus.LoggedOut) {
    <div class="md:col-10 flex justify-content-end">
      <p-button
        label="{{ 'Common.Login' | translate }}"
        styleClass="p-button-rounded p-button-primary p-button-sm"
        (onClick)="login()" />
    </div>
  }
  @if (loginState === ELoginStatus.LoggedIn) {
    @if ((userName$ | async) !== null) {
      <div class="md:col-4">
        <p-tabs [value]="activeMenuItemIndex" [showNavigators]="false">
          <p-tablist>
            @for (item of accountMenuItems; track item; let i = $index) {
              <p-tab [value]="i">
                <a
                  data-testid="accountMenuItem"
                  [routerLink]="item.routerLink"
                  pRipple
                  class="flex align-items-center gap-2 p-tab-link">
                  <span class="p-tab-text"> {{ item.label ?? '' | translate }}</span>
                </a>
              </p-tab>
            }
          </p-tablist>
        </p-tabs>
      </div>
    }
    <div class="md:col-6 flex">
      <div class="md:col-5">
        @if (isActiveAccount && (selectedOrganization ?? 0 > 0) && (selectedCountryId ?? 0 > 0)) {
          <app-algolia-search
            [customerOrganizationId]="selectedOrganization ?? 0"
            [customerCountryId]="selectedCountryId ?? 0" />
        }
      </div>
      @if (organizations$ | async; as organizations) {
        <div class="md:col-4 accounts-dropdown align-content-center p-0">
          <p-select
            id="organization"
            [options]="organizations ?? []"
            [(ngModel)]="selectedOrganization"
            optionLabel="organization.name"
            optionValue="organizationId"
            (onChange)="onChangeOrganization($event)" />
        </div>
      }
      @if ((userName$ | async) !== null) {
        <div class="md:col-3 profile-button align-content-center p-0">
          <p-splitButton
            data-testid="profile"
            [label]="(userName$ | async) || ''"
            [model]="profileMenu"
            styleClass="p-button-text p-button-plain mr-2"
            text />
        </div>
      }
    </div>
  }
</div>
